/* Coastal Cowgirl Co. — theme.js */
(function () {
  'use strict';

  /* ---------- mobile navigation ---------- */
  function initNav() {
    var toggle = document.querySelector('[data-nav-toggle]');
    var drawer = document.getElementById('mobile-nav');
    if (!toggle || !drawer) return;

    toggle.addEventListener('click', function () {
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      drawer.hidden = open;
    });
  }

  /* ---------- product gallery ---------- */
  function initGallery() {
    var gallery = document.querySelector('[data-gallery]');
    if (!gallery) return;

    var main = gallery.querySelector('[data-gallery-main] img');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    if (!main || !thumbs.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        setMainImage(thumb.getAttribute('data-full'));
        thumbs.forEach(function (t) { t.setAttribute('aria-current', 'false'); });
        thumb.setAttribute('aria-current', 'true');
      });
    });

    function setMainImage(src) {
      if (!src) return;
      main.removeAttribute('srcset');
      main.removeAttribute('sizes');
      main.src = src;
    }

    window.__cccSetMainImage = setMainImage;
    window.__cccSelectThumbByMediaId = function (mediaId) {
      thumbs.forEach(function (t) {
        var match = t.getAttribute('data-media-id') === String(mediaId);
        t.setAttribute('aria-current', match ? 'true' : 'false');
      });
    };
  }

  /* ---------- variant picker ---------- */
  function initVariants() {
    var picker = document.querySelector('[data-variant-picker]');
    if (!picker) return;

    var dataEl = picker.querySelector('[data-variant-data]');
    var selects = Array.prototype.slice.call(picker.querySelectorAll('select[data-option-index]'));
    var input = document.querySelector('[data-variant-input]');
    var button = document.querySelector('[data-add-button]');
    var label = document.querySelector('[data-add-label]');
    var priceEl = document.querySelector('[data-price]');
    var baseUrl = picker.getAttribute('data-url');

    if (!dataEl || !selects.length || !input) return;

    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    function currentOptions() {
      return selects.map(function (s) { return s.value; });
    }

    function findVariant(options) {
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === options[i]; });
      });
    }

    function update() {
      var variant = findVariant(currentOptions());

      if (!variant) {
        input.value = '';
        if (button) button.disabled = true;
        if (label) label.textContent = 'Unavailable';
        return;
      }

      input.value = variant.id;

      if (button) button.disabled = !variant.available;
      if (label) label.textContent = variant.available ? 'Add to cart' : 'Sold out';

      if (priceEl) {
        priceEl.innerHTML = variant.on_sale
          ? '<span class="price__was">' + variant.compare_at_price + '</span> <span class="price__now">' + variant.price + '</span>'
          : variant.price;
      }

      if (variant.featured_media_url && window.__cccSetMainImage) {
        window.__cccSetMainImage(variant.featured_media_url);
        if (window.__cccSelectThumbByMediaId) {
          window.__cccSelectThumbByMediaId(variant.featured_media_id);
        }
      }

      if (baseUrl && window.history && window.history.replaceState) {
        window.history.replaceState({}, '', baseUrl + '?variant=' + variant.id);
      }
    }

    selects.forEach(function (s) { s.addEventListener('change', update); });
  }

  /* ---------- collection filters + sort ---------- */
  function initFilters() {
    var form = document.querySelector('[data-filter-form]');
    if (!form) return;

    form.addEventListener('change', function () {
      var params = new URLSearchParams();

      form.querySelectorAll('input[type="checkbox"]:checked').forEach(function (box) {
        params.append(box.name, box.value);
      });

      var sort = form.querySelector('select[name="sort_by"]');
      if (sort && sort.value) params.set('sort_by', sort.value);

      var query = params.toString();
      window.location.href = window.location.pathname + (query ? '?' + query : '');
    });
  }

  /* ---------- keep the header cart count honest ---------- */
  function initCartCount() {
    var el = document.querySelector('[data-cart-count]');
    if (!el) return;

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (form && form.getAttribute('action') === '/cart/add') {
        // let the native submit happen; count refreshes on the next page load
      }
    });

    if (window.performance && performance.getEntriesByType) {
      var nav = performance.getEntriesByType('navigation')[0];
      if (nav && nav.type === 'back_forward') {
        fetch('/cart.js', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (cart) { el.textContent = cart.item_count; })
          .catch(function () {});
      }
    }
  }

  function init() {
    initNav();
    initGallery();
    initVariants();
    initFilters();
    initCartCount();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run when a section is re-rendered in the theme editor
  document.addEventListener('shopify:section:load', init);
})();
